import { getInputEvent } from '@/helpers/device';
import { CommonConstants } from '@/config/constant';

export default {
  mounted(el) {
    const inputEvent = getInputEvent();
    el.addEventListener(
      inputEvent,
      (e) => {
        const value = e.target.value;
        if (e.inputType == 'deleteContentBackward' || e.which == CommonConstants.BACKSPACE_KEYCODE) {
          const lastChar = value.slice(-1);
          if (lastChar == ' ') {
            e.target.value = value.substring(0, value.length - 1) ;
          }
        } else {
          e.target.value = value
            .replace(/\D/g, '')
            .replace(/(\d{4})/, '$1 ')
            .replace(/(\d{4}) (\d{4})/, '$1 $2 ')
            .replace(/(\d{4}) (\d{4}) (\d{4})/, '$1 $2 $3 ')
            .replace(/(\d{4}) (\d{4}) (\d{4}) (\d{4})/, '$1 $2 $3 $4');
        }
      },
      true
    );
  },
};
